import { createStyles } from '@asuikit/styles';

export default createStyles((theme) => ({
  title: {
    lineHeight: 1,
    padding: 0,
    margin: 0,
    fontWeight: 400,
    fontSize: theme.fontSizes.md,
  },
}));
